interface TelegramConnectionStatus {
  connected: boolean;
  linked: boolean;
}

export type TelegramConnectionState = "unlinked" | "alerts-disabled" | "alerts-enabled";

/** Distinguishes Telegram identity linking from permission to send bot alerts. */
export function getTelegramConnectionState(
  status: TelegramConnectionStatus | null | undefined,
): TelegramConnectionState {
  if (!status?.linked) return "unlinked";
  return status.connected ? "alerts-enabled" : "alerts-disabled";
}
